module.exports = __webpack_public_path__ + "img/bz.2d951d45.png";